module.exports = __webpack_public_path__ + "img/croma.8e2a6ed9.svg";